/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ValidateCouponResponseDuration } from './validateCouponResponseDuration';

export interface ValidateCouponResponse {
  code: string;
  promotion_code_id: string;
  name?: string | null;
  percent_off?: number | null;
  amount_off_cents?: number | null;
  currency?: string | null;
  duration: ValidateCouponResponseDuration;
  duration_in_months?: number | null;
  restricted_plan_slug?: string | null;
  restricted_cadence?: string | null;
}
